export const SocialPublishingPath = {
  title: "Social Publishing",
  newTitle: "Publishing",
  path: "/social-publishing",
  calendar: {
    title: "Social Publishing - Calendar",
    path: "/social-publishing/calendar"
  }
};
